import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NgxSvgService {
  public loadedSvgs: Map<string, string> = new Map<string, string>();
}
